import React from 'react'
import styled from 'styled-components/macro'
import { translate } from '../util/translate'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0;

  > * {
    margin-right: 16px;
  }
`

const Title = styled.p`
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 25px;
  text-transform: uppercase;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0;
`

const Pagination = styled.span`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  color: #757575;
`

const ButtonText = styled.button`
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  border: none;
  background: transparent;
  color: #56a0d3;
  opacity: 0.8;
  text-transform: uppercase;
  padding: 0;
  cursor: pointer;
  text-decoration: underline;
  outline: none;

  &:hover {
    color: #428cbf;
  }
`

type GroupHeaderProps = {
  title: string
  pagination: string
  onSeeMore?: () => void
}

export const GroupHeader: React.FC<GroupHeaderProps> = ({ title, pagination, onSeeMore }) => (
  <Wrapper>
    <Title>{title}</Title>
    <Pagination>{pagination}</Pagination>
    {onSeeMore !== undefined && <ButtonText onClick={() => onSeeMore()}>{translate('See all')}</ButtonText>}
  </Wrapper>
)
